import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';

// Lazy load Accounts page
const Accounts = lazy(() => import('../Pages/Accounts'));

function AccountingBooksRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                path="/:lng/business/accounting-books"
                render={() => (
                    <Suspense fallback={<Loading />}>
                        <Accounts history={history} />
                    </Suspense>
                )}
            />
        </Switch>
    );
}

export default AccountingBooksRoute;

function Loading() {
    return (
        <div className="wrapper">
            <span>Loading</span>
        </div>
    );
}
